import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, Table } from 'primeng';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IPageResult } from '../../interfaces/page-result';
import { ISupplierFeedbackFilter } from '../../interfaces/supplier-feedback/supplier-feedback-filter';
import { SupplierFeedbackService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { flatten } from '../../utils/flatten';

import { ISupplierFeedback } from '../../interfaces/supplier-feedback/supplier-feedback';

@Component({
  selector: 'supplier-feedback-list',
  templateUrl: './supplier-feedback-list.component.html',
  styleUrls: ['./supplier-feedback-list.component.css'],
})
export class SupplierFeedbackListComponent implements OnInit {
  public page: IPageResult<ISupplierFeedback> = {
    items: [],
    total: 0,
  };

  public customers: SelectItem[];
  public suppliers: SelectItem[];
  public filter: Subject<ISupplierFeedbackFilter>;
  public filterVal: ISupplierFeedbackFilter;
  public isLoaded: boolean = false;
  public selectedFeedback = null;

  // todo: load the array with all the outcome types using the supplier feedback service
  //feedbackOutcomes: any[];
  statusFeedback: any[];

  constructor(
    private vmeInboxJobsService: VmeInboxJobsService,
    private feedbackService: SupplierFeedbackService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<ISupplierFeedbackFilter>();

    this.statusFeedback = [
      { label: 'All Status', value: null },
      { label: 'Open', value: 'Open' },
      { label: 'Resolved', value: 'Resolved' },
    ];

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    this.vmeInboxJobsService.getCustomers().then((res) => {
      var l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.customers = l;
    });

    this.vmeInboxJobsService.getSuppliers().then((res) => {
      var l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.suppliers = l;
    });
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'JobNumber',
      sortOrder: 1,
      filters: {
        jobNumber: { matchMode: 'contains' },
        status: { matchMode: 'contains' },
        customerIdList: { value: null },
        supplierIdList: { value: null },
      },
    };
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  onFeedbackDetails(feedback) {
    this.displayFeedbackDetails(feedback.id);
  }

  displayFeedbackDetails(id: number) {
    this.router.navigate([id], { relativeTo: this.route });
  }

  openFeedback(feedbackId) {
    this.router.navigate(['app/supplierFeedback/' + feedbackId]);
  }

  load(filter: ISupplierFeedbackFilter) {
    this.feedbackService.getPage(flatten(filter)).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0;
    this.filter.next(this.filterVal);
  }

  downloadToCSV() {
    this.feedbackService.downloadToCSV(this.filterVal);
  }
}
